<template>
  <div
    class="form-control"
    :class="[{'error': type === 'text' && modelValue?.length > maxLength || error}, ...formControlClass]"
  >
    <label
      class="label fs-10"
      v-if="label"
      :for="`id-${name}`"
    >
      {{ label }} {{inputValueLength}}
    </label>
    <div class="input-group" :class="{'disabled': disabled}">
      <input
        :id="`id-${name}`"
        :name="name"
        :value="modelValue"
        class="input fs-12 w-100"
        :type="type"
        :min="min"
        :step="step"
        :autocomplete="autocomplete"
        :placeholder="placeholder"
        :disabled="disabled"
        @input="$emit('update:modelValue', $event.target.value)"
        @change="$emit('change', $event.target.value)"
        @keydown.enter="submitValue"
      >
    </div>
    <small class="error fs-10" v-show="error">
      <sup>*</sup>{{ error }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'McInput',
  emits: ['update:modelValue', 'submit', 'change'],
  props: {
    placeholder: {type: String, default: '-'},
    name: {type: String, default: ''},
    label: {type: String, default: ''},
    error: {type: String, default: ''},
    showRequired: {type: Boolean, default: false},
    type: {type: String, default: 'text'},
    autocomplete: {type: String, default: 'off'},
    modelValue: {type: [String, Number], default: ''},
    disabled: {type: Boolean, default: false},
    min: {type: [Number, null], default: null},
    step: {type: [Number, String], default: ''},
    maxLength: {type: Number, default: 255},
    formControlClass: {type: Array, default: () => []},
    removeOnSubmit: {type: Boolean, default: false}
  },
  methods: {
    submitValue(event) {
      this.$emit('submit', event);
      if (this.removeOnSubmit) {
        this.$emit('update:modelValue', '');
      }
    }
  },
  computed: {
    inputValueLength() {
      if (this.type !== 'text') {
        return '';
      }
      return `${this.modelValue?.length ? this.modelValue.length : 0}/${this.maxLength}`;
    }
  }
};
</script>
